import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=0b5cbf2d&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=0b5cbf2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5cbf2d",
  null
  
)

export default component.exports